<template lang="pug">
    .settings-page.settings-messages
        settings-page-head
        .settings-page__body
            template(v-if="recipients")
                .messages-container(v-if="recipients.length")
                    .recipients
                        .recipient(v-for="recipient in unreadRecipientsFirst" @click="selectRecipient(recipient)" :class="{ active: currentRecipient && currentRecipient.id == recipient.id }")
                            user-profile-image(:user="recipient" size="sm")
                            .recipient-info
                                .recipient-info__name {{ recipient.name }}
                                .recipient-info__last-message(:class="{ unread: recipient.unread_messages }") {{ recipient.last_message }}
                    .messages
                        template(v-if="currentRecipient")
                            .message-list(ref="messageList")
                                .message-list-container
                                    template(v-for="message in messages")
                                        .message(:class="{ sent: message.sent, received: !message.sent }")
                                            .message-text {{ message.message }}
                                            .message-time {{ messageTime(message.created_at) }}
                            .message-input
                                .form-group.re-input.form-field
                                    input.message-input-control(v-model="message" @keyup.enter="send" placeholder="Type a message here..." autocomplete="off")
                                re-button.btn-circle.btn-danger(@click="send" :loading="sending" :disabled="message.length <= 0")
                                    svg-icon(iconId="settings-messages")
                        p.text-center.mt-4(v-else) Select user from the list to send a message.
                .messages-empty(v-else) You don't have any messages yet.

</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

const EventBus = window.VueEventBus

export default {
    name: 'settings-messages',

    data() { return {
        recipients: null,
        currentRecipient: null,
        messages: [],
        message: '',
        sending: false,
    }},

    computed: {
        ...mapGetters(['authUser']),

        unreadRecipientsFirst() {
            return this.recipients.sort((a, b) => {
                if (!a.unread_messages && b.unread_messages) {
                    return 1
                }

                if (a.unread_messages && !b.unread_messages) {
                    return -1
                }

                return 0
            })
        },
    },

    async created() {
        this.startOfToday = moment().startOf('day')
        this.startOfYear = moment().startOf('year')

        const { data: { data: recipients } } = await axios.get('/api/customer/lairdnd-chat/recipient')
        this.recipients = recipients
    },

    methods: {
        moment,

        messageTime(time) {
            const momentTime = moment(time)
            let format = 'h:mm A'
            if (momentTime.isBefore(this.startOfYear)) {
                format = 'MMMM D, y ' + format
            } else {
                if (momentTime.isBefore(this.startOfToday)) {
                    format = 'MMMM D ' + format
                }
            }
            return momentTime.format(format)
        },

        async selectRecipient(recipient) {
            const { data: { data: messages } } = await axios.get(`/api/customer/lairdnd-chat/recipient/${recipient.id}/message`)
            this.messages = messages
            this.currentRecipient = recipient

            recipient.unread_messages = false
            recipient.last_message = messages.slice(-1)[0]?.message || ''

            EventBus.$emit('lairdnd-messages-read')

            this.$nextTick(() => {
                this.$refs.messageList.scrollTo({ top: this.$refs.messageList.scrollHeight })
            })
        },

        async send() {
            if (this.message.length > 0) {
                try {
                    this.sending = true

                    const { data: { data: message } } = await axios.post(`/api/customer/lairdnd-chat/recipient/${this.currentRecipient.id}/message`, {
                        message: this.message,
                    })

                    this.messages.push(message)
                    this.currentRecipient.last_message = this.message
                    this.message = ''
                } finally {
                    this.sending = false
                }
            }
        },
    }
}
</script>
